/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankIdMessages200,
  GetApiV1BankIdMessages401,
  GetApiV1BankIdMessages404,
  GetApiV1BankIdMessages500,
  GetApiV1BankIdMessagesPathParams,
  GetApiV1BankIdMessagesQueryResponse,
} from "../../types/bankAuxiliaresController/GetApiV1BankIdMessages.ts";
import { bankMessagesViewModelSchema } from "../bankMessagesViewModelSchema.ts";

export const getApiV1BankIdMessagesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BankIdMessagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankIdMessages200Schema = z.lazy(
  () => bankMessagesViewModelSchema,
) as unknown as ToZod<GetApiV1BankIdMessages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankIdMessages401Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdMessages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BankIdMessages404Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdMessages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankIdMessages500Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdMessages500>;

export const getApiV1BankIdMessagesQueryResponseSchema = z.lazy(
  () => getApiV1BankIdMessages200Schema,
) as unknown as ToZod<GetApiV1BankIdMessagesQueryResponse>;
